import _indexOf from 'lodash/indexOf';

/**
 * Looks for a flag set on the backend for a page which has had its element's line
 * heights adjusted for a rendering improvement.  This is required for backwards compatibility.
 *
 * @param tags
 * @returns
 */
export const hasBoundingBoxAdjustedTag = (tags: string[]): boolean => {
  return _indexOf(tags, 'bounding_boxes_adjusted') !== -1;
};
